import { useState } from "react";
import { ShoppingBag, Check } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { trackEvent, trackMetaEvent } from "@/components/Analytics";

// Sits alongside BuyNowButton on every product detail page — Buy Now goes
// straight to Stripe for a single item, this instead queues the item (with
// whatever options are currently selected) into the persistent cart so a
// customer can build a multi-item order before checking out once via the
// cart drawer.
export const AddToCartButton = ({
  productPath,
  testId = "add-to-cart-button",
  name,
  thumb,
  unitPrice,
  priceFrom = false,
  selectedOptions = null,
  disabled = false,
}) => {
  const { addItem } = useCart();
  const [justAdded, setJustAdded] = useState(false);

  const handleClick = () => {
    trackEvent("add_to_cart_click");
    trackMetaEvent("AddToCart", { content_ids: [productPath], content_type: "product" });
    addItem({ productPath, name, thumb, unitPrice, priceFrom, selectedOptions, quantity: 1 });
    toast.success(`${name} added to cart`);
    setJustAdded(true);
    window.setTimeout(() => setJustAdded(false), 1600);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      data-testid={testId}
      className="btn-secondary disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {justAdded ? (
        <><Check size={14} /> Added</>
      ) : (
        <><ShoppingBag size={14} /> Add to Cart</>
      )}
    </button>
  );
};
